module.exports = __webpack_public_path__ + "static/media/google-play-badge.c68e1c2f.svg";